import { apiSlice } from '../../api/apiSlice';
import * as constants from '../../constants';

export const scoreCardFilterSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getScorecardFilter: builder.query({
            query: (arg: any) => {
                const {
                    year,
                    month,
                    parentClientId,
                    clientId,
                    programId,
                    projectId,
                    countryId,
                    geolocationId,
                } = arg;
                return {
                    url: constants.SEARCH_SCORECARD,
                    params: {
                        year,
                        month,
                        parentClientId,
                        clientId,
                        programId,
                        projectId,
                        countryId,
                        geolocationId,
                    },
                };
            },
        }),
        getScorecardFilterByRole: builder.query({
            query: (arg: any) => {
                const {
                    employeenumber,
                    applicationRoleId,
                    year,
                    month,
                } = arg;
                return {
                    url: constants.EMPLOYEE_SCORECARDS_BY_ROLE,
                    params: {
                        employeenumber,
                    applicationRoleId,
                    year,
                    month,
                    },
                };
            },
        }),
        getParentClientFilter: builder.query({
            query: (arg: any) => {
                const {
                    year,
                    month,
                    scorecardVersionId,
                    clientId,
                    programId,
                    projectId,
                    countryId,
                    geolocationId,
                } = arg;
                return {
                    url: constants.SEARCH_PARENTCLIENTS,
                    params: {
                        year,
                        month,
                        scorecardVersionId,
                        clientId,
                        programId,
                        projectId,
                        countryId,
                        geolocationId,
                    },
                };
            },
        }),
        getClientFilter: builder.query({
            query: (arg: any) => {
                const {
                    year,
                    month,
                    scorecardVersionId,
                    parentClientId,
                    programId,
                    projectId,
                    countryId,
                    geolocationId,
                } = arg;
                return {
                    url: constants.SEARCH_CLIENTS,
                    params: {
                        year,
                        month,
                        scorecardVersionId,
                        parentClientId,
                        programId,
                        projectId,
                        countryId,
                        geolocationId,
                    },
                };
            },
        }),
        getProgramFilter: builder.query({
            query: (arg: any) => {
                const {
                    year,
                    month,
                    scorecardVersionId,
                    parentClientId,
                    clientId,
                    projectId,
                    countryId,
                    geolocationId,
                } = arg;
                return {
                    url: constants.SEARCH_PROGRAMS,
                    params: {
                        year,
                        month,
                        scorecardVersionId,
                        parentClientId,
                        clientId,
                        projectId,
                        countryId,
                        geolocationId,
                    },
                };
            },
        }),
        getProjectFilter: builder.query({
            query: (arg: any) => {
                const {
                    year,
                    month,
                    scorecardVersionId,
                    parentClientId,
                    clientId,
                    programId,
                    countryId,
                    geolocationId,
                } = arg;
                return {
                    url: constants.SEARCH_PROJECTS,
                    params: {
                        year,
                        month,
                        scorecardVersionId,
                        parentClientId,
                        clientId,
                        programId,
                        countryId,
                        geolocationId,
                    },
                };
            },
        }),
        getCountryFilter: builder.query({
            query: (arg: any) => {
                const {
                    year,
                    month,
                    scorecardVersionId,
                    parentClientId,
                    clientId,
                    programId,
                    geolocationId,
                } = arg;
                return {
                    url: constants.SEARCH_COUNTRIES,
                    params: {
                        year,
                        month,
                        scorecardVersionId,
                        parentClientId,
                        clientId,
                        programId,
                        geolocationId,
                    },
                };
            },
        }),
        getSiteFilter: builder.query({
            query: (arg: any) => {
                const { year, month, scorecardVersionId, parentClientId, clientId, programId, countryId } =
                    arg;
                return {
                    url: constants.SEARCH_SITES,
                    params: {
                        year,
                        month,
                        scorecardVersionId,
                        parentClientId,
                        clientId,
                        programId,
                        countryId,
                    },
                };
            },
        }),
        getScorecardAgents: builder.query({
            query: (arg: any) => {
                const { year, month, scorecardVersionId, scorecardRoleId,payoutApprover } = arg;
                return {
                    url: constants.SCORECARD_AGENTS,
                    params: { year, month, scorecardVersionId, scorecardRoleId,payoutApprover },
                };
            },
        }),
        getAgentDailyMetrics: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month, scorecardVersionId } = arg;
                return {
                    url: constants.AGENT_DAILY_METRICS,
                    params: { employeenumber, year, month, scorecardVersionId },
                };
            },
        }),
        getUserByID: builder.query({
            query: (arg: any) => {
                const { filterParam,searcherEmpNo,getAllEmps } = arg;
                return {
                    url: constants.SEARCH_ID,
                    params: { filterParam,searcherEmpNo,getAllEmps },
                };
            },
        }),
        getUserByName: builder.query({
            query: (arg: any) => {
                const { filterParam,searcherEmpNo,getAllEmps } = arg;
                return {
                    url: constants.SEARCH_NAME,
                    params: { filterParam,searcherEmpNo,getAllEmps },
                };
            },
        }),
        getScorecardByID: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month } = arg;
                return {
                    url: constants.SEARCH_SCORECARD_BY_ID,
                    params: { employeenumber, year, month },
                };
            },
        }),
        getScoreCardRoleId: builder.query({
            query: (arg: any) => {
                const { employeenumber } = arg;
                return {
                    url: constants.DISPUTE_GET_SCORECARD_ROLEID,
                    params: { employeenumber },
                };
            },
        }),
        getManagerApproverScorecards: builder.query({
            query: (arg: any) => {
                const {
                    employeenumber,
                    year,
                    month,
                } = arg;
                return {
                    url: constants.GET_MANAGER_APPROVER_SCORECARD,
                    params: {
                        employeenumber,
                        year,
                        month,
                    },
                };
            },
        }),
    }),
});

export const {
    useGetScorecardAgentsQuery,
    useGetAgentDailyMetricsQuery,
    useGetParentClientFilterQuery,
    useGetScorecardFilterQuery,
    useGetScorecardFilterByRoleQuery,
    useGetClientFilterQuery,
    useGetProgramFilterQuery,
    useGetProjectFilterQuery,
    useGetCountryFilterQuery,
    useGetSiteFilterQuery,
    useGetUserByIDQuery,
    useGetUserByNameQuery,
    useGetScorecardByIDQuery,
    useGetScoreCardRoleIdQuery,
    useGetManagerApproverScorecardsQuery,
} = scoreCardFilterSlice;
